import React from "react";
import { PageShell } from "../components/landing/PageShell";
import { ContactForm } from "../components/landing/ContactForm";
import { CONTACT_EMAIL } from "../data/site";
import { Mail, Instagram, Facebook } from "lucide-react";
import { useSignup } from "../components/SignupProvider";

export default function Contact() {
  const { openSignup } = useSignup();

  return (
    <PageShell
      title="Contact Us"
      subtitle="We'd love to hear from you. Whether you have a question, feedback, or want to partner with us, our team is here to help."
    >
      <div className="rounded-3xl border border-[#2F5E43]/10 bg-white p-8 shadow-[0_8px_30px_rgba(0,0,0,0.04)]">
        <div className="flex items-center gap-4">
          <span className="flex h-14 w-14 items-center justify-center rounded-2xl bg-[#E4EDE6] text-[#2F5E43]">
            <Mail className="h-6 w-6" />
          </span>
          <div>
            <p className="text-sm text-[#8AA583]">Email us anytime</p>
            <a
              href={`mailto:${CONTACT_EMAIL}`}
              className="font-heading text-2xl font-semibold text-[#111E16] transition-colors hover:text-[#2F5E43]"
              data-testid="contact-email-link"
            >
              {CONTACT_EMAIL}
            </a>
          </div>
        </div>
        <p className="mt-6 leading-relaxed text-[#4A5F52]">
          Our team typically replies within one to two business days. For press, partnership,
          or support enquiries, this is the best way to reach us.
        </p>
      </div>

      <ContactForm />

      <div className="rounded-3xl border border-[#2F5E43]/10 bg-[#E4EDE6]/40 p-8">
        <h2 className="font-heading text-xl font-semibold text-[#111E16]">
          Want early access?
        </h2>
        <p className="mt-2 leading-relaxed text-[#4A5F52]">
          Join the waitlist or become a beta tester and help shape the future of women's
          safety.
        </p>
        <div className="mt-5 flex flex-col gap-3 sm:flex-row">
          <button
            onClick={() => openSignup("waitlist")}
            className="inline-flex items-center justify-center rounded-full bg-[#2F5E43] px-7 py-3 font-medium text-white transition-colors hover:bg-[#244A34]"
            data-testid="contact-waitlist-btn"
          >
            Join the Waitlist
          </button>
          <button
            onClick={() => openSignup("beta")}
            className="inline-flex items-center justify-center rounded-full bg-white px-7 py-3 font-medium text-[#2F5E43] transition-colors hover:bg-[#F2F5F2]"
            data-testid="contact-beta-btn"
          >
            Become a Beta Tester
          </button>
        </div>
      </div>

      <div>
        <h2 className="font-heading text-xl font-semibold text-[#111E16]">Follow us</h2>
        <div className="mt-4 flex gap-3">
          <a href="https://www.instagram.com/sistersafe.app" target="_blank" rel="noopener noreferrer" aria-label="Instagram" className="flex h-11 w-11 items-center justify-center rounded-full border border-[#E8EBE9] bg-white text-[#2F5E43] transition-colors hover:bg-[#2F5E43] hover:text-white">
            <Instagram className="h-5 w-5" />
          </a>
          <a href="https://www.facebook.com/SisterSafeApp" target="_blank" rel="noopener noreferrer" aria-label="Facebook" className="flex h-11 w-11 items-center justify-center rounded-full border border-[#E8EBE9] bg-white text-[#2F5E43] transition-colors hover:bg-[#2F5E43] hover:text-white">
            <Facebook className="h-5 w-5" />
          </a>
        </div>
      </div>
    </PageShell>
  );
}
